// dynamic-price.js - Clean UI version

function getBasePrice() {
  const priceSpan = document.querySelector('.price-item--sale') ||
                    document.querySelector('.price-item--regular') ||
                    document.querySelector('.price-item');

  if (!priceSpan) return null;

  const priceText = priceSpan.textContent.replace(/,/g, '').trim();
  const match = priceText.match(/(\d+(?:\.\d{1,2})?)/);

  if (!match) return null;

  return Math.round(parseFloat(match[1]) * 100); // paise
}

function formatPrice(paise) {
  return `Rs. ${(paise / 100).toFixed(2)}`;
}

function updateDisplayedTotal() {
  const basePrice = getBasePrice();
  const quantityInput = document.querySelector('input[name="quantity"], input[type="number"], .quantity__input');

  if (!basePrice || !quantityInput) return;

  const qty = parseInt(quantityInput.value) || 1;
  const total = basePrice * qty;

  // Find or create "total price" element
  let totalEl = document.querySelector('#calculated-total-price');
  if (!totalEl) {
    totalEl = document.createElement('div');
    totalEl.id = 'calculated-total-price';
    totalEl.style.fontWeight = '600';
    totalEl.style.fontSize = '1.1rem';
    totalEl.style.color = '#2c3e50'; // dark gray/black
    totalEl.style.marginTop = '10px';
    totalEl.style.padding = '6px 10px';
    totalEl.style.background = '#f9f9f9';
    totalEl.style.border = '1px solid #e5e5e5';
    totalEl.style.borderRadius = '6px';

    // Insert just below price block
    const priceWrapper = document.querySelector('.price');
    if (priceWrapper && priceWrapper.parentNode) {
      priceWrapper.parentNode.insertBefore(totalEl, priceWrapper.nextSibling);
    }
  }

  totalEl.textContent = `Total: ${formatPrice(total)}`;
}

function setupPriceUpdater() {
  const quantityInput = document.querySelector('input[name="quantity"], input[type="number"], .quantity__input');

  if (!quantityInput) return;

  // Remove old listeners
  quantityInput.removeEventListener('input', updateDisplayedTotal);
  quantityInput.removeEventListener('change', updateDisplayedTotal);

  // Attach listeners
  quantityInput.addEventListener('input', updateDisplayedTotal);
  quantityInput.addEventListener('change', updateDisplayedTotal);

  // Variant dropdowns
  const variantSelects = document.querySelectorAll('select[name="id"], .product-form__input--dropdown select');
  variantSelects.forEach(select => {
    select.removeEventListener('change', delayedUpdate);
    select.addEventListener('change', delayedUpdate);
  });

  // Initial run
  updateDisplayedTotal();
}

function delayedUpdate() {
  setTimeout(updateDisplayedTotal, 300);
}

document.addEventListener('DOMContentLoaded', setupPriceUpdater);
window.addEventListener('load', () => setTimeout(setupPriceUpdater, 500));
